<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <p
      v-if="showError"
      class="red--text lighten-3 px-2 text-small text-center"
      v-html="UpdateError"
    ></p>
    <template v-slot:activator="{ on, attrs }">
      <page-title title="my profile">
        <button
          color="var(--grey)"
          class="text--small edit-profile-button"
          small
          text
          v-bind="attrs"
          v-on="on"
        >
          edit profile
        </button>
      </page-title>
    </template>

    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span class="text-h5">Edit Profile</span>
        <v-btn color="var(--red)" x-large icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="updateInfo">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="First Name"
                  v-model="firstname"
                  :disabled="loading"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Last Name"
                  v-model="lastname"
                  :disabled="loading"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Username"
                  v-model="username"
                  :disabled="loading"
                  hint="Username may not contain special characters"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <vue-phone-number-input
                  label="Phone"
                  v-model="phone"
                  :disabled="loading"
                  clearable
                ></vue-phone-number-input>
                {{ phone }}
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="var(--red)" text @click="dialog = false"> Close </v-btn>
        <v-btn
          color="var(--purple)"
          @click="updateInfo"
          text
          type="submit"
          :loading="loading"
          :disabled="loading"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//phone number module
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import axios from "axios";
import PageTitle from "./PageTitle.vue";
//import store to be able to get username or id and then set it to router params
import { mapGetters } from "vuex";

export default {
  components: {
    PageTitle,
    VuePhoneNumberInput,
  },

  data: () => ({
    firstname: null,
    lastname: null,
    phone: null,
    username: null,
    dialog: false,
    loading: false,
    showError: false,
  }),
  methods: {
    async updateInfo() {
      this.loading = true;
      const { username, phone, firstname, lastname } = this;
      //parse only fields to be updated
      let fields = {};
      if (firstname) {
        fields.firstname = firstname;
      }
      if (lastname) {
        fields.lastname = lastname;
      }
      if (phone) {
        fields.phone = phone;
      }
      if (username) {
        fields.username = username;
      }
      //destructure fields to be updated into the payload
      const response = await axios.post("/profile/update", {
        ...fields,
      });
      //stop loading once you get a response from server
      if (response.data) {
        this.loading = false;
      }

      //if error
      if (response.data.error) {
        this.updateError = response.data.message;
        this.loading = false;
        this.showError = true;
      }

      //if no error, get the new profile information
      if (!response.data.error) {
        this.loading = false;
        this.dialog = false;
        window.location.reload();
      }
    },
  },

  computed: {
    ...mapGetters({
      current_user: "auth/user",
    }),
  },
};
</script>

<style scoped>
.edit-profile-button {
  font-size: 85%;
  color: var(--grey);
  opacity: 0.45;
  font-weight: lighter;
}
button {
  text-transform: lowercase;
}
</style>